/* DASKI header - ドロワー開閉 / メガ展開（タッチ・キーボード） / 追従 */
(function () {
  /* ---------- SP ドロワー（ヘッダー下にスライドダウン） ---------- */
  const drawer = document.getElementById('DaskiDrawer');
  const headerEl = document.querySelector('daski-header');
  if (drawer) {
    const toggleBtns = document.querySelectorAll('[data-daski-drawer-toggle]');
    const closeBtns = drawer.querySelectorAll('[data-daski-drawer-close]');

    // ヘッダーの直下に出すため、開く瞬間に top を実測
    const positionUnderHeader = () => {
      if (!headerEl) return;
      drawer.style.top = Math.round(headerEl.getBoundingClientRect().bottom) + 'px';
    };

    const open = () => {
      positionUnderHeader();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      toggleBtns.forEach((b) => {
        b.setAttribute('aria-expanded', 'true');
        b.setAttribute('aria-label', 'メニューを閉じる');
      });
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      toggleBtns.forEach((b) => {
        b.setAttribute('aria-expanded', 'false');
        b.setAttribute('aria-label', 'メニューを開く');
      });
    };
    const toggle = () => (drawer.classList.contains('is-open') ? close() : open());

    toggleBtns.forEach((b) => b.addEventListener('click', toggle));
    closeBtns.forEach((b) => b.addEventListener('click', close));
    window.addEventListener('resize', () => {
      if (drawer.classList.contains('is-open')) positionUnderHeader();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
        toggleBtns[0] && toggleBtns[0].focus();
      }
    });
  }

  /* ---------- PC メガ（タッチ/キーボード補助。ホバーは CSS） ---------- */
  const megas = Array.from(document.querySelectorAll('[data-daski-mega]'));
  const closeAllMegas = (except) => {
    megas.forEach((m) => {
      if (m === except) return;
      m.classList.remove('is-open');
      const t = m.querySelector('.daski-header__nav-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  };

  megas.forEach((mega) => {
    const trigger = mega.querySelector('.daski-header__nav-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const willOpen = !mega.classList.contains('is-open');
      closeAllMegas(mega);
      mega.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllMegas(null);
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-daski-mega]')) closeAllMegas(null);
  });

  /* ---------- 追従：下スクロールで隠す / 上スクロールで出す ---------- */
  const header = document.querySelector('daski-header');
  if (header && header.dataset.sticky !== 'false') {
    let lastY = window.pageYOffset;
    let ticking = false;
    const onScroll = () => {
      const y = window.pageYOffset;
      const past = y > header.offsetHeight;
      if (y > lastY && past) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      header.classList.toggle('is-scrolled', past);
      lastY = y;
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
  }
})();
